/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import * as React from 'react';
import classNames from 'classnames';
import DatePicker from 'react-datepicker';
import { DateTime } from 'src_common/utils/time/time';
import Icon from 'src/components/Icon/Icon';
import { CalendarIconWrapper, DateInputContainer } from './DateInput.style';

class DateInput extends React.PureComponent {
    /*static propTypes = {
        value: PropTypes.string,
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func,
        disabled: PropTypes.string,
    };*/

    constructor(props) {
        super(props);

        this.state = {
            focus: false
        };
    }

    setFocus = (focus) => {
        return () => {
            const { onFocus, onBlur } = this.props;

            if (focus === this.state.focus) {
                return;
            }

            if (focus && onFocus) {
                onFocus();
            } else if (!focus && onBlur) {
                onBlur();
            }

            this.setState({
                focus
            });
        };
    };

    onChange = (date) => {
        const { onChange } = this.props;

        if (date) {
            date = DateTime.from(date);
            date = date.format('YYYY-MM-DD');
        }

        if (onChange) {
            onChange(date);
        }
    };

    getValueDate = () => {
        const date = this.props.value;

        if (date) {
            return DateTime.from(date).format('YYYY-MM-DD');
        }

        return date;
    };

    render() {
        return (
            <div className={ classNames([ 'date-input', { 'is-focused': this.state.focus } ])}>
                <CalendarIconWrapper />
                <DateInputContainer>
                    <DatePicker
                        dateFormat='yyyy-MM-dd'
                        popoverTargetAttachment='top center'
                        popoverAttachment='top center'
                        popoverTargetOffset='50px 0'
                        placeholderText={this.props.placeholderText}
                        disabled={this.props.disabled ? this.props.disabled : false }
                        selected={ null }
                        {...this.props }
                        onFocus={ this.setFocus(true) }
                        onBlur={ this.setFocus(false) }
                        onChange={ this.onChange }
                        value={this.getValueDate()}
                    />
                </DateInputContainer>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default DateInput;
